import React, { Suspense, lazy, useEffect, useState } from 'react';
import { onFileViewerOpen, previewKindOf } from '../../utils/fileViewer';
import { Lightbox } from '../chat/Lightbox';

// 문서 해석기(jszip·pdf.js)는 처음 열 때만 내려받는다
const FileViewer = lazy(() => import('./FileViewer'));

const MIME_GUESS = { image: 'image/*', video: 'video/*' };

// App 에 한 번만 둔다. openFileViewer(...) 가 부르면 여기서 창을 띄운다.
// 사진·영상만 모인 목록은 원래 쓰던 사진 뷰어(확대·넘기기 제스처)로, 그 밖에는 파일 뷰어로.
export default function FileViewerHost() {
    const [open, setOpen] = useState(null); // { files, index }
    useEffect(() => {
        let seq = 0;
        return onFileViewerOpen(detail => setOpen({ ...detail, seq: ++seq }));
    }, []);
    if (!open) return null;
    const close = () => setOpen(null);

    const kinds = open.files.map(f => previewKindOf(f.name, f.mimetype));
    if (kinds.every(k => k === 'image' || k === 'video')) {
        const items = open.files.map((f, i) => ({
            fileUrl: f.url, downloadUrl: f.downloadUrl, originalName: f.name,
            mimetype: f.mimetype || MIME_GUESS[kinds[i]],
        }));
        return <Lightbox key={open.seq} mediaItems={items} initialIndex={open.index} onClose={close} />;
    }
    return (
        <Suspense fallback={null}>
            <FileViewer key={open.seq} files={open.files} index={open.index} onClose={close} />
        </Suspense>
    );
}
